export default {
  title: 'Congrats!',
  subtitle: 'You’re all set with %{name} Rewards',
}
